import { render, staticRenderFns } from "./EditRepairDialog.vue?vue&type=template&id=bf48ec0e&"
import script from "./EditRepairDialog.vue?vue&type=script&lang=ts&"
export * from "./EditRepairDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports